import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ForPatients from "@/pages/ForPatients";
import ForHospitals from "@/pages/ForHospitals";
import ForPersonnel from "@/pages/ForPersonnel";
import Contact from "@/pages/Contact";
import Partner from "@/pages/Partner";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminHospitals from "@/pages/admin/AdminHospitals";
import AdminPersonnel from "@/pages/admin/AdminPersonnel";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import { AuthProvider } from "@/context/AuthContext";
import RequireAdmin from "@/components/admin/RequireAdmin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            {/* Public site */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/for-patients" element={<ForPatients />} />
              <Route path="/for-hospitals" element={<ForHospitals />} />
              <Route path="/for-personnel" element={<ForPersonnel />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/partner" element={<Partner />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              element={
                <RequireAdmin>
                  <AdminLayout />
                </RequireAdmin>
              }
            >
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/contacts" element={<AdminContacts />} />
              <Route path="/admin/hospitals" element={<AdminHospitals />} />
              <Route path="/admin/personnel" element={<AdminPersonnel />} />
              <Route path="/admin/newsletter" element={<AdminNewsletter />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
